import { parsePhoneNumber } from 'libphonenumber-js';

import { PhoneDto } from 'services/user/userService.dto';

export const convertToPhoneDto = (phoneNumber: string, includeAreaCode = false): PhoneDto => {
  const parsedPhoneNumber = parsePhoneNumber(phoneNumber);
  const countryCode = parsedPhoneNumber.countryCallingCode;
  const areaCode = includeAreaCode ? parsedPhoneNumber.nationalNumber.substring(0, 3) : '';
  const number = includeAreaCode ? parsedPhoneNumber.nationalNumber.substring(3) : parsedPhoneNumber.nationalNumber;
  return { countryCode, areaCode, number };
};

export const convertToString = (phoneDto?: PhoneDto): string => {
  if (!phoneDto) return '';
  return `+${phoneDto.countryCode}${phoneDto.areaCode}${phoneDto.number}`;
};

export const formatMobilePhone = (phoneDto?: PhoneDto): string => {
  const convertedMobilePhone = convertToString(phoneDto);
  return formatStringPhoneNumber(convertedMobilePhone);
};

export const formatStringPhoneNumber = (phoneNumber: string): string => {
  const parsedPhoneNumber = parsePhoneNumber(phoneNumber);
  return parsedPhoneNumber ? parsedPhoneNumber.formatInternational() : '';
};
